import { render, staticRenderFns } from "./date-range-select.vue?vue&type=template&id=2b88042b&"
import script from "./date-range-select.vue?vue&type=script&lang=ts&"
export * from "./date-range-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports